import React from 'react';
import PropTypes from 'prop-types';
import ConnectButton from '../../../pages/_banner/ConnectButton';
import Wrapper from '../../../pages/_banner/Wrapper';
import useDialogLauncher from '../../_hooks/useDialogLauncher';
import { DialogManager } from '../../../dialogs_new/DialogManager';
import useRouter from '../../../hooks/useRouter';

DraftBanner.propTypes = {
  event: PropTypes.object.isRequired
};

export default function DraftBanner(props) {
  const { event, creator } = props;

  const launch = useDialogLauncher();
  const { history } = useRouter();

  function onCancel() {
    launch(DialogManager.EventClose.Config(event.id));
  }

  function onFindPartners() {
    launch(DialogManager.EventManage.Config(event.id, '/invite-populate'));
  }

  return (
    <Wrapper
      color="gray"
      creator={creator}
      title={(
        <>
          Your event is missing required fields!
        </>
      )}
      subtitle={(
        <>
          To make your event visible on the platform, please provide the missing information
          below. After providing these details, your event will be active and you'll be able
          to collaborate with others.
        </>
      )}
    >
      <div className="flex flex-col sm:flex-row space-x-0 space-y-4 sm:space-x-4 sm:space-y-0">
        <ConnectButton outline={true} onClick={onCancel}>
          Cancel event
        </ConnectButton>
        <ConnectButton onClick={() => history.push('/edit')} gray={true}>
          View missing fields
        </ConnectButton>
      </div>
    </Wrapper>
  );
};
